<template>
  <a-modal
    :title="title"
    :visible="visible"
    @cancel="handleCancel"
    @ok="handleCancel"
    @close="handleCancel"
    width="1200px">
    <a-table
      bordered
      rowKey="id"
      :columns="columns"
      :data-source="list"
      :row-selection="{ selectedRowKeys: selectedRowKeys, type: 'radio', onChange: onSelectChange}"
      :customRow="loadCustomRow"
      :pagination="false"
      :loading="loading">
    </a-table>
    <a-pagination
      class="ant-table-pagination"
      show-size-changer
      show-quick-jumper
      :pageSizeOptions="pageSizeOptions"
      :current="queryParam.pageNum"
      :total="total"
      :page-size="queryParam.pageSize"
      :showTotal="total => getTotal(total)"
      @showSizeChange="onShowSizeChange"
      @change="changeSize"
    />
    <div style="height: 25px"></div>
    <div class="bottom-control">
      <a-space>
        <a-button type="dashed" @click="handleCancel">{{$t('取消')}}</a-button>
      </a-space>
    </div>
  </a-modal>
</template>

<script>
import {ledgerBindList} from '@/api/shop/extraApplyLakala'

export default {
  name: 'LedgerBindList',
  props: {},
  data() {
    return {
      title: undefined,
      loading: false,
      visible: false,
      pageSizeOptions: ['10', '20', '50', '100'],
      selectedRowKeys: [],
      selectedRows: [],
      total: 0,
      queryParam: {
        no: undefined,
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      columns: [
        { title: '分账接收方编号', dataIndex: 'receiverNo' },
        { title: '分账接收方名称', dataIndex: 'receiverName' },
        { title: '审核状态', dataIndex: 'auditStatus' },
        { title: '审核处理说明', dataIndex: 'remark' },
      ],
    }
  },
  methods: {
    getTotal(total) {
      return this.$t('共') + total + this.$t('条')
    },
    handleCancel() {
      this.visible = false
      this.list = []
      this.reset()
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize(current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    reset() {
      this.form = { orderId: undefined, addressId: undefined, isAdmin: true }
      this.selectedRowKeys = []
      this.selectedRows = []
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows
    },
    handleDetail(no) {
      this.queryParam.no = no
      ledgerBindList(this.queryParam).then(res => {
        this.list = res.data.list
        this.total = res.data.total
        this.visible = true;
      }).finally(() => {
        this.loading = false
      });
    },
    loadCustomRow(record, index) {
      return {
        on: {
          click: () => {
            if (this.selectedRowKeys.find(e => e.id === record.id)) {
              return;
            }
            let selectedRowKeys = [record.id]
            let selectedRows = [record]
            this.onSelectChange(selectedRowKeys, selectedRows)
          }
        }
      }
    },
  }
}
</script>
